// extracted by mini-css-extract-plugin
export default {"container":"EditHistory_container__G2Sig"};